import MediaPackDeleteModal from './MediaPackDeleteModal';

export default MediaPackDeleteModal;
